import uuid from 'uuid'

// TODO: use this file only from models
// TODO: also make sure uuid is not used by other files

//TODO: remove `NEW_` prefix after getting rid of `generateClientId`
export const generateClientId: () => string = () => uuid.v4()
